import FixedFooter from './Index.vue'

FixedFooter.install = function(Vue) {
    Vue.component(FixedFooter.name, FixedFooter)
}

export default FixedFooter
